import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Business-role route guard. Deny by default:
 *   - anonymous users are redirected to /login (carrying the intended location),
 *   - a signed-in user whose business roles don't intersect `roles` is sent to 403.
 *
 * Mirrors PAGE_ACCESS in menuData and the backend authorization map, so a user
 * can only reach pages their role owns.
 *
 *   <Route element={<AccessRoute roles={[ROLES.DISPATCHER]} />}>
 *     <Route path="owned-tugs" element={<OwnedTugsPage />} />
 *   </Route>
 */
export default function AccessRoute({ roles = [] }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const userRoles = user?.roles || [];
  if (roles.length > 0 && !roles.some((r) => userRoles.includes(r))) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
